<template>
    <v-container fluid>
        <address-form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('forms.title_prefix.add')"
        ></address-form>
    </v-container>
</template>

<script>
import AddressModel from '@/models/Address'
import AddressForm from './Form'

export default {
    props: ['reseller_id'],

    components: {
        AddressForm,
    },

    data: () => {
        return {
            address: new AddressModel(),
        }
    },

    methods: {
        saved() {
            this.$router.go(-1)
        },
    },

    computed: {
        model() {
            let model = this.address
            model.reseller_id = this.reseller_id
            return model
        },
    },
}
</script>

<style></style>
